import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";
import { ui } from "../lib/ui";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-8 py-16">
      <h1 className="font-serif text-3xl font-bold text-[#8B1A1A] mb-2">Forgot password</h1>
      <p className="text-sm text-[#5A4441] mb-8">Enter your email and we'll send a reset link.</p>
      {sent ? (
        <div className={ui.card + " p-6 text-[#210201]"} data-testid="forgot-sent-message">
          If that email is registered, a reset link is on its way. Check your inbox (and spam).
          <div className="mt-5"><Link to="/login" className={ui.btnSecondary}>Back to login</Link></div>
        </div>
      ) : (
        <form onSubmit={submit} className={ui.card + " p-6 space-y-5"} data-testid="forgot-form">
          <div>
            <label className={ui.label}>Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={ui.input} data-testid="forgot-email-input" />
          </div>
          <button type="submit" disabled={loading} className={ui.btnPrimary + " w-full"} data-testid="forgot-submit-btn">
            {loading ? "Sending…" : "Send reset link"}
          </button>
        </form>
      )}
    </div>
  );
}
